import { StoreReviewEntity } from '@/services/types/store-review.type';
import Image from 'next/image';

interface Props extends StoreReviewEntity {
  className?: string;
}
const RecommendReviewCard = (review: Props) => {
  return (
    // desktop:h-[304px] desktop:w-[513px] w-[260px] h-[251px]
    <div
      key={review.id}
      className="desktop:px-10 desktop:py-10 desktop:rounded-xl h-full w-full rounded-lg bg-white px-6 py-7"
    >
      {/* 1. 지점 배지 */}
      <div className="border-stroke-grayblue desktop:py-3 mb-5 inline-flex items-center justify-center rounded-full border bg-white px-3 py-2">
        {/* 맵핀 이미지 */}
        <Image
          src="/images/icons/icon_map_pin.svg"
          alt="지점 위치 아이콘"
          width={16}
          height={16}
          loading="eager"
        />
        <span className="text-main-orange typo-15 desktop:typo-20 font-bold">
          {review.storeName}
        </span>
      </div>

      {/* 2. 작성자 + 코스명 */}
      <div className="mb-3">
        <h3 className="text-level-1 typo-20 desktop:typo-24 mb-2 font-extrabold">
          {review.username}
        </h3>
      </div>

      {/* 3. 리뷰 본문 */}
      <p className="typo-15 text-level-3 desktop:typo-18 desktop:leading-[28px] line-clamp-4 leading-[23px] font-medium whitespace-pre-wrap">
        {review.reviewText.replace(/\n/g, ' ')}
      </p>
    </div>
  );
};

export default RecommendReviewCard;
